var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tipsContianer j-pay-tips"},[_c('i',{staticClass:"closeTipsBtn",on:{"click":_vm.close}}),_vm._v(" "),_c('p',{staticClass:"tips-content"},[_vm._v("請跳轉前往儲值頁面")]),_vm._v(" "),_c('footer',{staticClass:"tips-footer"},[_c('a',{staticClass:"skipPayBtn j-skip-pay-btn",on:{"click":_vm.pay}},[_vm._v("跳轉")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc172a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PayTips.vue
// module id = null
// module chunks = 